import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

// Assuming rawData is imported or passed as prop
const rawData = {
  visit: [
    { id: 1, start_datetime: '2025-05-27 10:15:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 2, start_datetime: '2025-05-27 11:45:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 3, start_datetime: '2025-05-27 11:50:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 4, start_datetime: '2025-06-02 15:20:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 5, start_datetime: '2025-06-02 15:35:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 6, start_datetime: '2025-06-02 10:05:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    // ... add more if desired
  ]
};

const PoolVisits = () => {
  // Step 1: Filter
  const filtered = rawData.visit.filter(
    (v) => v.amenity === 'clubhouse-pool--jacuzzi'
  );

  // Step 2: Group by hour
  const visitCountsByHour = Array(24).fill(0); // index = hour

  filtered.forEach((visit) => {
    const hour = new Date(visit.start_datetime).getHours();
    visitCountsByHour[hour]++;
  });

  // Step 3: Chart data config
  const labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);

  const data = {
    labels,
    datasets: [
      {
        label: 'Visits by Hour (clubhouse-pool--jacuzzi)',
        data: visitCountsByHour,
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: 'Clubhouse Pool/Jacuzzi Visits by Hour' },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Number of Visits' },
      },
      x: {
        title: { display: true, text: 'Hour of Day' },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default PoolVisits;
